import { useEffect } from "react";

/**
 * Shows the browser's native "leave site?" confirmation dialog when the user
 * tries to close/reload the tab while `enabled` is true.
 *
 * Note: browsers do NOT allow customizing the dialog text — a generic message
 * is always shown. Setting `returnValue` is what triggers the prompt.
 */
const useBeforeUnload = (enabled: boolean) =>
{
   useEffect(() =>
   {
      if (!enabled) return;

      const handleBeforeUnload = (event: BeforeUnloadEvent) =>
      {
         event.preventDefault();
         // Required for the prompt to show in Chrome and older browsers.
         event.returnValue = "";
         return "";
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => window.removeEventListener("beforeunload", handleBeforeUnload);
   }, [enabled]);
};

export default useBeforeUnload;
